import { useEffect, useRef } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { useVolumeHover } from "~/feature/chart/providers/VolumeHoverProvider";
import type { INewsMarker } from "~/feature/chart/types";
import { getNearestTimelineIndex } from "~/feature/chart/utils";

import { CURSOR_LEAVE_DELAY_MS } from "./constants";

export const useNewsCursor = () => {
  const { timeline } = useCoreChart();
  const { setHoveredIndex } = useVolumeHover();
  const leaveTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelPendingLeave = () => {
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
      leaveTimeout.current = null;
    }
  };

  useEffect(() => cancelPendingLeave, []);

  const onBadgeEnter = (marker: INewsMarker) => {
    cancelPendingLeave();
    setHoveredIndex(
      getNearestTimelineIndex(timeline, Date.parse(marker.publishedAt))
    );
  };

  const onBadgeLeave = () => {
    cancelPendingLeave();
    leaveTimeout.current = setTimeout(() => {
      leaveTimeout.current = null;
      setHoveredIndex(null);
    }, CURSOR_LEAVE_DELAY_MS);
  };

  return { onBadgeEnter, onBadgeLeave };
};
